var _style, _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgCalendarClock = function SvgCalendarClock(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlSpace: "preserve",
    id: "calendar-clock_svg__Layer_1",
    x: 0,
    y: 0,
    viewBox: "0 0 24 24"
  }, props), _style || (_style = /*#__PURE__*/React.createElement("style", null, ".calendar-clock_svg__st0{fill:none;stroke:#000;stroke-linecap:round;stroke-linejoin:round}")), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 17.5,
    cy: 17.5,
    r: 6,
    className: "calendar-clock_svg__st0"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.5 17.5h-2v-3M9.5 18.5h-8c-.6 0-1-.4-1-1v-14c0-.6.4-1 1-1h18c.6 0 1 .4 1 1V10M5.5.5v5M15.5.5v5M.5 7.5h20",
    className: "calendar-clock_svg__st0"
  })));
};
export default SvgCalendarClock;